export default {
  headline: 'Vítejte',
  welcomeText: process.env.VUE_APP_WELCOME_TEXT_EN ||
  'do systému řízení výuky innovation mecom.'
}
